import { GetAccountGroupsShareInvitedApi } from "@/features/accounts/account-group/services/get-account-groups-share-invited-api";
import { GetAccountGroupsShareInvitedRequestModel } from "@/features/accounts/account-group/services/get-account-groups-share-invited-model";

/// 口座グループ共有招待情報取得
export class GetAccountGroupsShareInvitedService {
  private getAccountGroupsShareInvitedApi = new GetAccountGroupsShareInvitedApi();

  /**
   * 口座グループ共有招待情報取得
   */
  public async getAccountGroupsShareInvited(param: GetAccountGroupsShareInvitedRequestModel) {
    return await this.getAccountGroupsShareInvitedApi.getAccountGroupsShareInvited(param);
  }
}

